import classNames from 'classnames'

import { isValueStringType } from '../../../../utils/common'
import { Counter, TABLE_VARIANT } from '../../../Counter'
import Text from '../../../Text'
import { BirdviewCardDragHandle } from '../BirdviewCardDragHandle'

import * as styles from './BirdviewCardHeader.module.css'

function BirdviewCardHeader({
  TitleBefore = null,
  children,
  count,
  dragHandleProps,
  isAI,
  title,
  titleBeforeProps,
}) {
  return (
    <header className={styles.header}>
      <div className={styles.titleWrap}>
        {dragHandleProps ? (
          <BirdviewCardDragHandle dragHandleProps={dragHandleProps} />
        ) : null}
        {TitleBefore ? <TitleBefore {...titleBeforeProps} /> : null}
        <Text
          Element='h2'
          className={classNames(styles.title, { [styles.aiTitle]: isAI })}
          title={isValueStringType(title) ? title : undefined}
        >
          {title}
        </Text>
        {count != null ? (
          <Counter count={count} variant={TABLE_VARIANT} />
        ) : null}
      </div>
      {children}
    </header>
  )
}

export default BirdviewCardHeader
